// Hero section
const algolia = {
  init() {
    document.addEventListener('click', (evt) => {
      if(evt.target) {
        if(evt.target.classList.contains('ais-facet--header') || evt.target.closest('.ais-facet--header')) {
          const facetWrapper = evt.target.closest('.ais-facet-item');
          
          if(facetWrapper) {
            facetWrapper.classList.toggle('opened');
          }
        }
      }
   });
  }
}

export default algolia